import { inject } from '@angular/core';
import { SmartEditLauncherService } from '@spartacus/smartedit/root';

import { DatalayerService } from '../services/datalayer.service';

export const appInitDatalayer = () => {
  const smartEditLauncherService = inject(SmartEditLauncherService);
  const datalayerService = inject(DatalayerService);

  if (!smartEditLauncherService.isLaunchedInSmartEdit()) {
    datalayerService.init();
  }
};
